import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierHealthScoreUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierHealthScore} from "~/pages/supplier-360/types/Supplier360Types";

/**
 * The six-domain health breakdown for one entity (`GET supplier_360/health_score/?entity={id}`, §2.11).
 * Exactly 6 rows once computed, an empty list before — well under one page, so `results` is the lot.
 */
export function useSupplierHealthScoresQuery(entityId: number | undefined) {
    const url = supplierHealthScoreUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierHealthScore>>(url)).data.results,
        enabled: Boolean(entityId),
    });
}
